module.exports = __webpack_public_path__ + "images/emoji/tm.5e247242b16c2d60f8a2.png";